import { Component } from '@angular/core';
import { StateService } from '../../../../shared/service/state.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { RefactorService } from '../../services/refactor.service';
import { UtilsService } from '../../../../core/services/utils.service';
import { RefactorRequest } from '../../../../core/models/refactor-request';
import { AI_MODELS } from '../../../../core/constants/enums';


@Component({
  selector: 'refactor-pages-uploaded-files',
  standalone: false,
  templateUrl: './uploaded-files.component.html',
  styleUrl: './uploaded-files.component.scss'
})
export class UploadedFilesComponent {

  //uploadedFiles: File[] = [];
  uploadedFile: File[] | null = []; // Ahora solo un archivo
  //Maps to save URLS
  fileUrl: string = '';
  //fileUrls = new Map<File, string>();
  selectedAction: string = '';

  // Variables for each checkbox
  refactor: boolean = false;
  modernize: boolean = false;
  migrate: boolean = false;

  // Variable to save file ZIP content
  extractedFiles: any[] = [];

  projectId: string = '';
  moduleId: string = '';
  token: string = '';

  constructor(
    private stateService: StateService,
    private router: Router,
    private refactorService: RefactorService,
    private activatedRoute: ActivatedRoute,
    private utilsService: UtilsService
  ) {

  }

  ngOnInit() {
    this.projectId = this.utilsService.getProjectId();
    this.moduleId = this.utilsService.getModuleId();
    this.stateService.uploadedFiles$.subscribe((files: File[]|null) => {
      this.uploadedFile = files; // Si hay archivo, lo guardamos, si no, vaciamos la lista
      this.updateFileUrl();// Actualiza la URL si hay archivo
    });
  }

  updateFileUrl() {
    if (this.uploadedFile) {
      this.fileUrl = URL.createObjectURL(this.uploadedFile[0]);
    } else {
      this.fileUrl = '';
    }
  }

  removeFile() {
    this.uploadedFile = [];
    this.fileUrl = '';
    this.stateService.clearFile(); // Borra el archivo en el servicio
  }

  onSelect(action: string) {
    this.selectedAction = this.selectedAction === action ? '' : action;
  }

  // Metod to check if at least one checkbox is selected
  isAnyCheckboxSelected(): boolean {
    return this.refactor || this.modernize || this.migrate;
  }

  returnfileUpload() {
    this.router.navigate(['/coding/refactor/upload-files']);
  }

  generateCode() {
    if (this.isAnyCheckboxSelected()) {
      if(sessionStorage.getItem('GenAiToken') !== null ){
        const tokenSession = sessionStorage.getItem('GenAiToken');
        if(tokenSession !== null){
          this.token = tokenSession;
        }
      } else {
        this.token = "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIwMTk1ODRkZC0zYzRhLTcxMjEtODIxNS1lNWRiOTg1N2YzYzYiLCJlbWFpbCI6ImphaXJvLmdhcmNpYS1hcGFyaWNpb0BpbmV0dW0uY29tIiwidW5pcXVlX25hbWUiOiJHYXJjaWEtQXBhcmljaW8gSmFpcm8iLCJVc2VySWQiOiIwMTk1ODRkZC0zYzRhLTcxMjEtODIxNS1lNWRiOTg1N2YzYzYiLCJVc2VyRW1haWwiOiJqYWlyby5nYXJjaWEtYXBhcmljaW9AaW5ldHVtLmNvbSIsIkV4dGVybmFsSWQiOiIzMmJhZmQzNS0zNTcxLTRkYTgtYTY0OC01ZGNiZTBhYjZkNWMiLCJFeHRlcm5hbERvbWFpbiI6ImluZXR1bS5jb20iLCJCdWlsZE51bWJlciI6IjIwMjUuMi42LjExMTIiLCJUb2tlblR5cGUiOiJBY2Nlc3NUb2tlbiIsIkFnZW50SWQiOiIxZmRlNTliMy04NDQ5LTQ5ZjctOTQ5ZS01NzhlMmE1M2VjOGUiLCJPcmdhbmlzYXRpb25JZCI6IjM5NDA5NTQ2LTdlN2EtNDUxMS1iYzMyLTNkYTE3ZjVhYzc1ZSIsIkVtYmVkZGluZ01vZGVsSWQiOiI4OGIzN2QwNC0yNGM1LTQ3ZTUtYmE1YS05NzEyMDAzM2U1N2MiLCJyb2xlIjoiVXNlciIsIm5iZiI6MTc0MjIxMjgxMSwiZXhwIjoxNzQyMjg0ODExLCJpYXQiOjE3NDIyMTI4MTEsImlzcyI6Imh0dHBzOi8vcGxheWdyb3VuZC1wcHIuaW5ldHVtLmdyb3VwLyJ9.hUyonrYgF2EabEMTUfo9sqX4obAPu1eoC7bGaphhB0PFEYSnE8BcmCf8F2VB5qdbsdD8_bkjya3h30lk6YpUGg"; // Reemplaza con el token real
      }
      let refactorRequest: RefactorRequest = {
        projectId: this.projectId,
        moduleId: this.moduleId,
        criteriaId: AI_MODELS.GEMINI_FLASH
      }

      this.refactorService.sendRefactorRequest(this.token, refactorRequest).subscribe({
        next: (res) => {
          this.stateService.setRefactorResponse(res);
        },
        error: (error) => {
          console.error("Error al enviar la refactorización:", error);
        }
      });
      this.router.navigate(['/coding/refactor/generate-code']);
    } else {
      console.log('No se seleccionó ninguna opción.');
    }
  }

}
